export const LOCATION_ALIASES: Record<string, string> = {
  'Воронежская' : 'Воронежская область',
  'Татарстан':' Ресбублика Татарстан',
  'Калининградская': 'Калининградская область',
  'Курская':'Курская область',
  'Липецская':'Липецская область',
  'Московская': 'Московская область',
  'Нижегородская':'Нижегородская область',
  'Пермская': 'Пермский край',
  'Ростовская':'Ростовская область',
  'Рязанская':'Рязанская область',
  'Самарская':'Самарская область',
  'Ленинградская': 'Ленинградская область',
  'Тульская':'Тульская область',
  'Башкортостан':'Рксбуплика Баскортостан',
  'Ярославская':'Ярославская область ',

  'Свердловская': 'Свердловская область',
  'Новосибирская': 'Новосибирская область',
  'Челябинская': 'Челябинская область',
}
